import EditorCommandQueueRow from './_parts/EditorCommandsQueueRow/EditorCommandsQueueRow';
import { Wrapper } from './EditorCommandsQueue.style';

export type EditorCommandsQueueProps = {
  commands: IEditorCommand[];
};

export function EditorCommandsQueue(props: EditorCommandsQueueProps) {
  const { commands = [] } = props;

  if (!commands.length) {
    return null;
  }

  function renderCall(command: IEditorCommand) {
    return <EditorCommandQueueRow key={command.id} command={command} />;
  }

  function renderCalls() {
    return commands.map((command: IEditorCommand) => renderCall(command));
  }

  return (
    <Wrapper className='EditorCommandsQueue-wrapper' data-testid='EditorCommandsQueue-wrapper'>
      {renderCalls()}
    </Wrapper>
  );
}

export default EditorCommandsQueue;
